
import { defineComponent, onMounted } from "vue";
import { useRouter } from "vue-router";
import Utils from "@/components/Utils";
import store from "@/store/index";

export default defineComponent({
  setup() {
    const router = useRouter();
    onMounted(async () => {
      const isLogin = await Utils.isLogin();
      if (!isLogin) location.href = `${Utils.baseUrl}/virtual/login/`;

      const isFirstLogin = await Utils.isFirstLogin();

      const campaign = await Utils.getCampaign();
      store.commit("setCampaign", campaign);

      if (isFirstLogin) router.push("/information");
      else router.push("/park");
    });
  },
});
